import { render, staticRenderFns } from "./PlafondPage.vue?vue&type=template&id=3598b111"
import script from "./PlafondPage.vue?vue&type=script&lang=js"
export * from "./PlafondPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports